import React from 'react';

import { Flex } from '@this/shared/ui/layout/flex';
import { Radio, RadioGroup } from '@this/shared/ui/inputs/radio';
import { styled } from '@this/constants/themes';
import Button from '@this/shared/atoms/button';
import { Select } from '@this/shared/ui/inputs/select';

export type DepartmentFilterSortType = 'CREATED_AT_ASC' | 'CODE_ASC' | 'CODE_DESC';

const sortOptions: Record<DepartmentFilterSortType, string> = {
  CREATED_AT_ASC: '登録順',
  CODE_ASC: 'コード昇順',
  CODE_DESC: 'コード降順'
};

type Props = {
  onSearch: (text: string, disabled: boolean, order: DepartmentFilterSortType) => void;
};
export const DepartmentFilter = ({ onSearch }: Props) => {
  const [filterText, setFilterText] = React.useState('');
  const [filterDisabled, setFilterDisabled] = React.useState<boolean>(false);
  const [sortType, setSortType] = React.useState<DepartmentFilterSortType>('CREATED_AT_ASC');

  return (
    <OrganizationDepartmentFilter className="e2e-department-filter">
      <Flex alignItems="center">
        <OrganizationDepartmentFilterLabel>検索ワード</OrganizationDepartmentFilterLabel>
        <OrganizationDepartmentFilterField
          value={filterText}
          placeholder="検索"
          onChange={e => setFilterText(e.target.value)}
        />
      </Flex>
      <Flex alignItems="center">
        <OrganizationDepartmentFilterLabel>ステータス</OrganizationDepartmentFilterLabel>
        <RadioGroup
          layout="horizontal"
          value={filterDisabled}
          onChange={(_, value) => setFilterDisabled(value === 'true')}
        >
          <Radio name="status" value={false}>
            有効
          </Radio>
          <Radio name="status" value>
            無効
          </Radio>
        </RadioGroup>
      </Flex>
      <Flex alignItems="center">
        <FilterLabel>ソート順</FilterLabel>
        <Select value={sortType} onChange={e => setSortType(e.target.value as DepartmentFilterSortType)}>
          {Object.entries(sortOptions).map(([k, v]) => (
            <option key={k} value={k}>
              {v}
            </option>
          ))}
        </Select>
      </Flex>
      <FilterButton onClick={() => onSearch(filterText, filterDisabled, sortType)}>検索</FilterButton>
    </OrganizationDepartmentFilter>
  );
};

const OrganizationDepartmentFilter = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 8px;
`;

const OrganizationDepartmentFilterLabel = styled.label`
  font-weight: normal;
  margin-right: 5px;
`;

const OrganizationDepartmentFilterField = styled.input.attrs({ type: 'text' })`
  flex-grow: 1;
  width: auto !important;
  margin-bottom: 0 !important;
`;

const FilterLabel = styled.label`
  font-weight: normal;
  margin-right: 5px;
`;

const FilterButton = styled(Button)`
  width: 100px;
  margin-left: 16px;
`;
